// extracted by mini-css-extract-plugin
export default {"root":"Success-root-a488ac59b99a018b9652ac2afa9208d2","link":"Success-link-b136db068545d1a8c865876a7bb195fe"};